import { useCallback, useState } from "react";

/** Uma inserção nova no live region também anuncia resultados com texto idêntico. */
export function useLiveAnnouncement() {
  const [announcement, setAnnouncement] = useState({ message: "", sequence: 0 });
  const announce = useCallback((message: string) => {
    setAnnouncement((previous) => ({ message, sequence: previous.sequence + 1 }));
  }, []);
  return [announcement, announce] as const;
}
